var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"clearable":false,"enum":_vm.enumValues,"labels":_vm.labels,"rules":[(v) => !!v || 'Lütfen bu alanı doldurun.'],"label":"Tahsilat Türü"},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }